import type { AccordionDesignTokens } from '@primeuix/themes/types/accordion'

export default {
  root: {
    transitionDuration: '{transition.duration}',
  },
  panel: {
    borderColor: '{content.border.color}',
    borderWidth: '0 0 1px 0',
  },
  header: {
    last: {
      bottomBorderRadius: '{content.border.radius}',
      activeBottomBorderRadius: '0',
    },
    color: '{text.color}',
    first: {
      borderWidth: '1px',
      topBorderRadius: '{content.border.radius}',
    },
    padding: '1.125rem',
    focusRing: {
      color: '{focus.ring.color}',
      style: '{focus.ring.style}',
      width: '{focus.ring.width}',
      offset: '{focus.ring.offset}',
      shadow: 'inset {focus.ring.shadow}',
    },
    fontWeight: '600',
    hoverColor: '{text.color}',
    toggleIcon: {
      color: '{text.muted.color}',
      hoverColor: '{text.color}',
      activeColor: '{text.color}',
      activeHoverColor: '{text.color}',
    },
    activeColor: '{text.color}',
    borderColor: '{content.border.color}',
    borderWidth: '0 1px 1px 1px',
    borderRadius: '0',
    activeHoverColor: '{content.hover.background}',
  },
  content: {
    color: '{text.color}',
    padding: '1.125rem',
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderWidth: '0 1px 1px 1px',
  },
  colorScheme: {
    dark: {
      header: {
        background: '{surface.800}',
        hoverBackground: '{surface.700}',
        activeBackground: '{surface.800}',
        activeHoverBackground: '{surface.700}',
      },
    },
    light: {
      header: {
        background: '{surface.50}',
        hoverBackground: '{surface.100}',
        activeBackground: '{surface.50}',
        activeHoverBackground: '{surface.100}',
      },
    },
  },
} satisfies AccordionDesignTokens
